import * as React from 'react';
import { observer } from 'mobx-react';

import { Box } from '@chakra-ui/react';

import { useAppManager } from 'core/hooks';
import { Button } from 'components';

import { EmptyConnTable } from './EmptyContent';
import { TableActions } from './TableActions';
import { TableContent } from './TableContent';
import Paginate from '../actions/paginate';
import { TableStore } from './tableStore';

export const TableBox = ({ wrapperStyle = {}, children }) => {
  return (
    <Box
      as='section'
      py='6'
      overflowX='visible'
      mx='auto'
      px={0}
      {...wrapperStyle} // to override styles from parent component
    >
      {children}
    </Box>
  );
};

const ExpandActions = observer(({ tableStore }) => {
  if (!tableStore?.numExpandableRows) return null;

  return (
    <>
      <Button
        text='Collapse All'
        icon='arrow_up'
        onClick={() => tableStore.collapseAll()}
        size='small'
        outline
        iconPosition='right'
      />
      <Button
        text='Expand All'
        icon='arrow_down'
        onClick={() => tableStore.expandAll()}
        size='small'
        outline
        iconPosition='right'
        margin='0 8px 0 0'
      />
    </>
  );
});

export const Table = observer(
  ({
    conn,
    columns,
    actions,
    contentName,
    maxRows = -1,
    subRowsAccessor,
    wrapperStyle = {},
    RowActionButtons,
  }) => {
    let nodes = [];
    if (conn?.nodes) {
      ({ nodes } = conn);
    }

    const tableStore = useAppManager(
      TableStore,
      null,
      {
        conn,
        subRowsAccessor,
      },
      !!subRowsAccessor && nodes.length > 0,
    );

    const emptyTablePlaceholder = (
      <EmptyConnTable
        height={60 * conn.batchSize}
        contentName={contentName}
        conn={conn}
      />
    );

    let actualColumns = columns;
    if (RowActionButtons) {
      const actionColumn = {
        Header: 'Actions',
        Cell: function rowActions(row) {
          return (
            <div style={{ visibility: 'hidden' }}>
              <RowActionButtons node={row} />
            </div>
          );
        },
      };

      actualColumns = [...columns, actionColumn];
    }

    let finalActions = actions;
    if (tableStore) {
      finalActions = {
        ...actions,
      };
      finalActions.leftActions = [...actions.leftActions, ExpandActions];
    }

    return (
      <TableBox wrapperStyle={wrapperStyle}>
        {finalActions && (
          <TableActions
            conn={conn}
            actions={finalActions}
            columns={columns}
            tableStore={tableStore}
          />
        )}
        <TableContent
          nodes={nodes}
          columns={actualColumns}
          maxRows={maxRows}
          loading={conn?.loading}
          subRowsAccessor={subRowsAccessor}
          tableStore={tableStore}
          loadingRowCount={conn.batchSize}
          RowActionButtons={RowActionButtons}
          showEmptyPlaceholder={conn.noDataAfterLoading}
          emptyTablePlaceholder={emptyTablePlaceholder}
          conn={conn}
        />
        <Paginate conn={conn} contentName={contentName} maxRows={maxRows} />
      </TableBox>
    );
  },
);
